// ¿Se usa el onboarding de marca? (ADR-2026-09-28-onboarding-v2-etapa-1)
//
// Convive con el cuestionario de siempre hasta que se decida reemplazarlo:
//   - `VITE_ONBOARDING_MARCA=true` lo prende para todo el deploy;
//   - `localStorage['atlas:onboarding_marca_on'] = '1'` lo prende en un navegador, para
//     probarlo en producción sin cambiar el de nadie más.
// Se lee una vez al cargar: las rutas se arman con esto.

export function onboardingDeMarcaActivo(): boolean {
  if (import.meta.env.VITE_ONBOARDING_MARCA === 'true') return true;
  try {
    return localStorage.getItem('atlas:onboarding_marca_on') === '1';
  } catch {
    return false;
  }
}
